/* ----------------------- AVOID PUTTING CODE IN GLOBAL SCOPE  ----------------------------------- */
$(function () {
    /* ---- BEGIN LOCAL NAMED FUNCTIONS DECLARATION ----*/    
    // Localized variables kept in localizeddetails file
    var localizedJS = new localizedProductList();
    initialize();

    function initialize() {

        window.onpopstate = popState;
	 window.onresize = onResize;
        BindRadioButtons($(".prodTimeFilter"));
        BindCheckBoxes($('.tagFilter'));
        BindCheckBoxes($('.ratingFilter'));
        BindColors($(".filterColorBlock"));
	
        ParsePriceFilters($("#PriceMinDisplay"), $("#PriceMaxDisplay"));
        SetupPriceSlider($("#price-range"), $("#PriceMinDisplay"), $("#PriceMaxDisplay"));
        SetPriceKeyUp($("#price-range"), $("#PriceMinDisplay"), $("#PriceMaxDisplay"));
	
        SetupFilterMore($(".filterMore"));
        SetupFilterHeader($(".filterHeader"));
	  if (viewport().width < 800) {
           $('#collapsed').val('true');
            $('.filterHeader').each(function () {
                var hdr = $(this);
                var expandArrow = hdr.children("span.filterExpand");
                var filterDropDown = hdr.siblings("div.filterContent");
                //expandArrow.empty();
                if (!expandArrow.hasClass("filterExpandActive")) {
                    expandArrow.addClass("filterExpandActive");
                    //expandArrow.append("<span class='visually-hidden'>Collapse this filter</span>");
                    hdr.attr("aria-expanded", "false");
                    filterDropDown.attr("aria-hidden", "true");
                    hdr.siblings("div").slideToggle("fast");
                }

            });
        }
        $("#ApplyPriceFilter").unbind("click");
        $("#ApplyPriceFilter").bind("click", function(e){
            e.preventDefault();
        });
        $('#updatetriggerurl').bind("click", function (e) {
            UpdateFilterUrl();
        });
        
        $("a.skip[href='#mainContent']").click( function(e){
		e.preventDefault();
		$('#skipToProducts').show().focus();
	});
	
	$('#skipToProducts').click( function(e){
		$(this).hide();
		$('.productLink')[0].focus();
	});
	
		
	$('#skipToProducts').on( "keydown", function(e){
		if(e.which == 13){
			$(this).hide();
			$('.productLink')[0].focus();
		}
	});
	
	$("#skipToProducts").focusout(function() {
		$('#skipToProducts').hide();
	});
    
	$('#clearAllFilters').on("click", function (e) {
            clearAllFilters();
        });
        
        $('#clearAllFilters').on( "keydown", function(e){
        	if(e.which == 13){
            		clearAllFilters();
            }
        });
        $.widget("ui.dialog", $.extend({}, $.ui.dialog.prototype, { 
		 _title: function(title) { 
			var $title = this.options.title || '&nbsp;' 
			if( ("titleIsHtml" in this.options) && this.options.titleIsHtml == true ) 
				title.html($title); 
			else title.text($title); 
		} 
	}));
        $("#mainContent").on("click", ".videoLink", function(event){
		var lastFocus;
		event.preventDefault();
            lastFocus = document.activeElement;
            if ($('div#videoDialog').length < 1) {
                // add an empty div within the form, then will be used by the jquery-ui dialog
                $('<div/>', { id: "videoDialog", style: "display:none;" }).appendTo('form');
            }

            var controllerUrl = "/video/videodetails/" + $(this).attr("data-productid");
            var vidTitle = $(this).attr("title");
            var videoUrl;

            $.get(controllerUrl, function (data) {
                videoUrl = data.PublishedUrl;
                var vidMarkup = "<video id=\"azuremediaplayer\" class=\"azuremediaplayer amp-flush-skin amp-big-play-centered embed-responsive-item\" width=\"100%\" height=\"100%\" tabindex=\"0\">" + "</video>";
                $("#videoDialog").html(vidMarkup).dialog({
                    title: "<label for='azuremediaplayer_AzureHtml5JS_api'>" + vidTitle + "</label>",
                    titleIsHtml: true,
                    modal: true,
                    draggable: true,
                    resizable: false,
                    beforeClose: function (event, ui) {
                        // azure media player nicely stops the video when the ui-dialog element is removed. that's easy
                        $(".ui-dialog").remove();
                        myPlayer.dispose();
 	                 lastFocus.focus();
                        $('#videoDialog').attr('aria-hidden', 'true');
                    }
                });
                $('.ui-dialog-titlebar-close').attr({
                    'tabindex': '0',
                    'role': 'button'
                }).focus();

                var myPlayer = amp('azuremediaplayer', {
                	"nativeControlsForTouch": false,
                    autoplay: true,
                    controls: true,
                    logo: { enabled: false },
                    techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"]
                });

                // Add subtitles, if available
                if (data.EnglishSubtitleUrl && data.EnglishSubtitleUrl.length > 0) {
                    myPlayer.src([
                    { src: videoUrl, type: "application/vnd.ms-sstr+xml" }
                    ], [
                            { src: data.EnglishSubtitleUrl, srclang: "en", kind: "subtitles", label: "English" }
                    ]);
                } else {
                    myPlayer.src([{
                        src: videoUrl,
                        type: "application/vnd.ms-sstr+xml"
                    }]);
                }
            });
        });      
        $("#mainContent").on("keydown", ".videoLink", function(e){
        	if(e.which == 13){
			$(this).click();        	
        	}
        });
    
    
        //$('#clearAllFilters').addClass('hide').hide();
	//initializeState();
        UpdatePageFromUrl();

    }
    
    function initializeState(){
          var loc = window.location.href;
        var title = document.title;
        var keywords = $('meta[name="keywords"]').attr('content');
        var description = $('meta[name="description"]').attr('content');
		var urlArray = loc.split('/');
        var prot = urlArray[0];
        var host = urlArray[2];
		var url = prot + '//' + host;
		
		//history.pushState({title: title, keywords: keywords, description: description}, '', loc);
		
    }

	function filterLog(pagetype, pagevalue, filtertype, filtervalue) {
		var fl_success = function (result) { };
		var fl_error = function (result) { };
		
	
		//Log in Omniture.
		if (typeof s != "undefined") {
			s.prop18 = filtertype + " : " + filtervalue;//List Filter prop
			s.prop19 = filtertype;//List Filter Group prop
	        	s.eVar30 = s.prop18;//List Filter event variable expires at hit
	        	s.eVar32 = s.prop18;//List Filter event variable expires at order
	        	//s.events = '';//No event set up in SC for filtering
	        	pagetype = s.prop12;
	        	if (s.prop12 === "Search") { pagevalue = s.prop1; }//internal search prop 
	        	else { pagevalue = s.prop7; } //groupname, taggroupname, or storename }
	        	var s_code = s.t(); if (s_code) document.write(s_code);
		}
		
		//Log in Azure
		var querystring = "?pagetype=" + encodeURI(pagetype) + "&pagevalue=" + encodeURI(pagevalue) + "&filtertype=" + encodeURI(filtertype) + "&filtervalue=" + encodeURI(filtervalue);
		$.ajax({
		    type: "GET",
		    contentType: "application/json; charset=utf-8",
		    url: "/filters/logfilter" + querystring,
		    dataType: "json",
		    success: fl_success,
		    error: fl_error
		});
	}
	
    
    //Binds all the checkboxes that belong to the object
    function BindCheckBoxes(identifierObject)
    {
	    identifierObject.find(":checkbox").each(function() {
		    $(this).unbind("click");
		    $(this).bind("click", function(e){
			  CheckBoxAction(e, false);
		    });
	            $(this).unbind("keypress");
	            $(this).bind("keypress", function (e) {
	                //TODO on click update the product count and the products that are being returned.
	                if(e.which == 13){
		                CheckBoxAction(e, true);
	                }
	            });
	    });
    }

    function BindRadioButtons(identifierObject) {
        identifierObject.find(":radio").each(function () {
            $(this).unbind("click");
            $(this).bind("click", function (e) {
                RadioButtionAction(e, false);
            });
            $(this).unbind("keydown");
            $(this).bind("keydown", function (e) {
                //TODO on click update the product count and the products that are being returned.
                if(e.which == 13){
	                RadioButtionAction(e, true);
                }
                if(e.which == 38 || e.which == 40){
                	e.preventDefault();
                	var el = e.toElement || e.currentTarget;
                	if(e.which == 40){
                		var elem = $('#'+el.id);
                		var next = elem.parent().next().children('input');
                		if(next != undefined){
                			//elem.unbind('blur');
                			//next.checked = true;
                			next.focus();
                			//next.bind('blur', function(e){
                			//	if((e.toElement || e.currentTarget).checked){
                			//		RadioButtionAction(e, false);
                			//	}
                			//});
                		}
                	}else{
                	       var elem = $('#'+el.id);
                		var prev = elem.parent().prev().children('input');
                		if(prev != undefined){
                			//elem.unbind('blur');
                			//prev.checked = true;
                			prev.focus();
                			//prev.bind('blur', function(e){
                			//	if((e.toElement || e.currentTarget).checked){
                			//		RadioButtionAction(e, false);
                			//	}
                			//});
                		}
                	}
                }
            });
        });

    }

    //Bind all the colors in the color filter
    function BindColors(identifierObject) {
        identifierObject.each(function () {
            $(this).unbind("click");
            $(this).bind("click", function (e) {
			ColorButtonAction(e);
            });
            $(this).unbind("keydown");
            $(this).bind("keydown", function (e) {
                //TODO on click update the product count and the products that are being returned.
                if(e.which == 13){
	                ColorButtonAction(e);
                }

            });
        });
    }//end BindColors
    
    function RadioButtionAction(e, enter){
    	                var el = e.toElement || e.currentTarget;
	                var vals = el.id.split('_');
	                var c = $('#' + el.id);
	                var filterID = el.className;
	                var filterName = '#' + filterID;
	                var filterValue;
	                if(enter && !el.checked){
	                 el.checked = true;
	                 }
	                if (el.checked) {
	                    filterValue = vals[1];
	                }
	                else {
	                    filterValue = null;
	                }
	                var $chkobject = $(filterName);
	                //clear the value and uncheck the radio button if it's what's already checked.
	                if (filterValue == $chkobject[0].value) {
	                    el.checked = false;
	                    $chkobject.val('');
	                    removeFilterFromSelectedGroup(el);
	                    productListMeta.SetProductionTime("");
	                }
	                else {
	                    $chkobject.val(filterValue);
	                    $('.selectedProductionTime').remove();
	                    addSelectedProductionTime(el);
	                    productListMeta.SetProductionTime(el.id.split('_')[1]);
	                }
	                var loadFromUrl = $('#prodTimeFromUrl').val() == "true";
	                if (!loadFromUrl) {
	                    $('#currentPage').val(1);
	                } else {
	                    $('#prodTimeFromUrl').val("false");
	                }
	                //angular.el
	                angular.element(document.getElementById(filterID)).triggerHandler('change');
	                UpdateFilterUrl();
	
	                filterLog('', '', filterID, vals[1]);
	}
	 function ColorButtonAction(e){
	 	e.preventDefault();
                var el = e.toElement || e.currentTarget;
                var vals = el.id.split('_');
                var c = $('#' + el.id);
                if (c.hasClass("colorChecked")) {
                    c.removeClass("colorChecked");
                    c.children().css('display', 'none');
                    removeFilterFromSelectedGroup(el);
                    c.attr("aria-checked", false);
                } else {
                    c.addClass("colorChecked");
                    c.children().css('display', '');
                    addSelectedFilterColor(el);
                    c.attr("aria-checked", true);
                }
                var filter = '';
                var colorMeta = '';
                $('.colorChecked').each(function () {
                    var vals = this.id.split('_');
                    filter = filter + ' ' + vals[1];
                    colorMeta = colorMeta + '_' + this.attributes["aria-label"].value;
                });
                $('#colorFilter').val(filter);
                productListMeta.SetColor(colorMeta);
                var loadFromUrl = $('#colorFromUrl').val() == "true";
                if (!loadFromUrl) {
                    $('#currentPage').val(1);
                } else {
                    $('#colorFromUrl').val("false");
                }
                angular.element(document.getElementById('colorFilter')).triggerHandler('change');
                UpdateFilterUrl();

                filterLog('', '', 'Color', vals[1]);
          }
          
     function CheckBoxAction(e, enter){
     			var logfiltertype = '';
		        var logfiltervalue = '';

			    var el = e.toElement || e.currentTarget;
			    var vals = el.id.split('_');


			    var c = $('#' + el.id);
			    var filterID = el.classList[0];

			    var filterName = '#' + filterID;
			    var filterValue= ' ';
		        var checkedClass = filterID + "Checked";
		        if(enter && el.checked){
		        	el.checked = false;
		        }else if(enter){
		        	el.checked = true;
		        }
		        if (el.checked) { c.addClass(checkedClass); addFilterToSelectedGroup(c[0]); }
		        else { c.removeClass(checkedClass); removeFilterFromSelectedGroup(c[0]); }
		        if (filterID == "tagFilter") {
		            var tagGroups = [];
		            var tagMeta = '';
		            $('.' + checkedClass).each(function () {
		                var vals = this.id.split('_');
		                var groupID = vals[1];
		                logfiltertype = vals[1];//logging
		                logfiltervalue = vals[2];//logging
		                var i;
		                var contains = false;
		                for (i = 0; i < tagGroups.length; i++) {
		                    if (tagGroups[i].group == groupID) {
		                        tagGroups[i].tags.push(vals[2]);
		                        contains = true;
		                        break;
		                    }
		                }
		                if (!contains) {
		                    tagGroups.push({ 'group': groupID, 'tags': [vals[2]] });
		                }
		                tagMeta = tagMeta + '_' + this.attributes["aria-label"].value;
		            });
		            productListMeta.SetTags(tagMeta);
		            var j;
		            filterValue = '';
		            for (j = 0; j < tagGroups.length; j++) {
		                filterValue = filterValue + '#' + tagGroups[j].group + '_';
		                var k;
		                for (k = 0; k < tagGroups[j].tags.length; k++) {
		                    if (k > 0) {
		                        filterValue = filterValue + '-' + tagGroups[j].tags[k];
		                    } else {
                                filterValue = filterValue + tagGroups[j].tags[k];
		                    }
		                }
		            }
                    $('#currentPage').val(1);
		        } else {
		            $('#currentPage').val(1);
		            var ratingMeta = "";
		            var logvals = el.id.split('_');//logging just needs first rating
		            logfiltertype = logvals[0];//logging
		            logfiltervalue = logvals[1];//logging
		            $('.' + checkedClass).each(function () {
		                var vals = this.id.split('_');
		                filterValue = filterValue + ' ' + vals[1];
		                ratingMeta = ratingMeta + "_" + vals[1];
		            });
		            productListMeta.SetRating(ratingMeta);
		        }
		    
                //get and update the hidden input 
			    var $chkobject = $(filterName);
			    $chkobject.val(filterValue);
			    angular.element(document.getElementById(filterID)).triggerHandler('change');
			    UpdateFilterUrl();

			    filterLog('', '', logfiltertype, logfiltervalue);
	}
    ////Parse the min and max values in the price filter.
    function ParsePriceFilters(PriceMinObject, PriceMaxObject)
    {
	    PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum));
	    PriceMaxObject.val(parseFloat(PriceFilter.PriceMaximum));
    }

    function SetPriceKeyUp(SliderObject, PriceMinObject, PriceMaxObject)
    {
        PriceMinObject.on('blur',function () {
                if ($.isNumeric(PriceMinObject.val())) {
                    var min = PriceMinObject.val();
                    var max = PriceMaxObject.val();

                    if (min < parseFloat(PriceFilter.PriceMinimum)) {
                        PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum));
                    }

                    if (parseFloat(min) > parseFloat(max)) {
                        PriceMinObject.val(max);
                    }

                    SliderObject.slider("values", 0, PriceMinObject.val());
                } else {
                    PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum).toFixed(2));
                }
	          $('#currentPage').val(1);

                var priceMin = $('#PriceMinDisplay').val();
	        var priceMax = $('#PriceMaxDisplay').val();
	        $('#PriceMin').val(priceMin);
	        $('#PriceMax').val(priceMax);
                UpdateFilterUrl();
	        
	        $('#selectedPriceRange').remove();
	        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
	            addSelectedPriceRange(priceMin, priceMax);
	        }
	        
	        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
	        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
        });

        SliderObject.keyup(function () {
                if ($.isNumeric(PriceMinObject.val())) {
                    var min = PriceMinObject.val();
                    var max = PriceMaxObject.val();

                    if (min < parseFloat(PriceFilter.PriceMinimum)) {
                        PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum));
                    }

                    if (parseFloat(min) > parseFloat(max)) {
                        PriceMinObject.val(max);
                    }

                    SliderObject.slider("values", 0, PriceMinObject.val());
                } else {
                    PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum).toFixed(2));
                }

	          $('#currentPage').val(1);

                var priceMin = $('#PriceMinDisplay').val();
	        var priceMax = $('#PriceMaxDisplay').val();
	        $('#PriceMin').val(priceMin);
	        $('#PriceMax').val(priceMax);
                UpdateFilterUrl();
	        
	        $('#selectedPriceRange').remove();
	        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
	            addSelectedPriceRange(priceMin, priceMax);
	        }
	        
	        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
	        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
        });
	
	    PriceMaxObject.on('blur', function() {
		     	    if($.isNumeric(PriceMaxObject.val())){
		     		    var min = PriceMinObject.val();
				    var max = PriceMaxObject.val();
				
		                if (max > parseFloat(PriceFilter.PriceMaximum)){
		            	    PriceMaxObject.val(parseFloat(PriceFilter.PriceMaximum));
			          }
			      
			          if(parseFloat(min) > parseFloat(max)) {
				          PriceMaxObject.val(min);  
			          }
			      
			          SliderObject.slider("values", 1, PriceMaxObject.val());	
			     }else{
			         PriceMaxObject.val(parseFloat(PriceFilter.PriceMaximum).toFixed(2));
			    }
	              	$('#currentPage').val(1);
			    var priceMin = $('#PriceMinDisplay').val();
			        var priceMax = $('#PriceMaxDisplay').val();
			        $('#PriceMin').val(priceMin);
			        $('#PriceMax').val(priceMax);
			    UpdateFilterUrl();
			        
			        $('#selectedPriceRange').remove();
			        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
			            addSelectedPriceRange(priceMin, priceMax);
			        }
			        	
			              
			        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
			        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
	    });
	    $('.ui-slider-handle').on('blur', function () {
	    	var priceMin = $('#PriceMinDisplay').val();
	        var priceMax = $('#PriceMaxDisplay').val();
	        $('#currentPage').val(1);
	        $('#PriceMin').val(priceMin);
	        $('#PriceMax').val(priceMax);
	        UpdateFilterUrl();
	        
	        $('#selectedPriceRange').remove();
	        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
	            addSelectedPriceRange(priceMin, priceMax);
	        }
	        
	        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
	        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
	    });
	    
	    $('.ui-slider-handle').keyup(function () {
	        $('#currentPage').val(1);
	        var priceMin = $('#PriceMinDisplay').val();
	        var priceMax = $('#PriceMaxDisplay').val();
	        $('#PriceMin').val(priceMin);
	        $('#PriceMax').val(priceMax);
	        UpdateFilterUrl();
	        $('#selectedPriceRange').remove();
	        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
	            addSelectedPriceRange(priceMin, priceMax);
	        }
	        
	        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
	        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
	    });
	    	$('.ui-slider-handle').mouseup(function () {
	        $('#currentPage').val(1);
	        var priceMin = $('#PriceMinDisplay').val();
	        var priceMax = $('#PriceMaxDisplay').val();
	        $('#PriceMin').val(priceMin);
	        $('#PriceMax').val(priceMax);
	        UpdateFilterUrl();
	        $('#selectedPriceRange').remove();
	        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
	            addSelectedPriceRange(priceMin, priceMax);
	        }
	        
	        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
	        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
	    });
	    
	    $('#price-range').mouseup(function () {
	        $('#currentPage').val(1);
	        var priceMin = $('#PriceMinDisplay').val();
	        var priceMax = $('#PriceMaxDisplay').val();
	        $('#PriceMin').val(priceMin);
	        $('#PriceMax').val(priceMax);
	        UpdateFilterUrl();
	        $('#selectedPriceRange').remove();
	        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
	            addSelectedPriceRange(priceMin, priceMax);
	        }
	        
	        angular.element(document.getElementById('PriceMin')).triggerHandler('change');
	        angular.element(document.getElementById('PriceMax')).triggerHandler('change');
	    });
    }//end SetPriceKeyUp

    function SetupPriceSlider(SliderObject, PriceMinObject, PriceMaxObject)
    {
	    SliderObject.slider({
		    range: true,
		    animate: true,
		    min: PriceFilter.PriceMinimum,
		    max: PriceFilter.PriceMaximum,
		    step: PriceFilter.SliderStep,
		    values: PriceFilter.SliderValues ,
		    slide: function( event, ui ) {
		    		if(ui.value.toFixed(2) == ui.values[0].toFixed(2)){
			    		PriceMinObject.val(ui.values[0].toFixed(2));
			    	}
			    	else{
			    		PriceMaxObject.val(ui.values[1].toFixed(2));
			    		}
			    setTimeout(function () {
			        //UpdateFilterUrl();
			        //var priceMin = $('#PriceMin').val();
			        //var priceMax = $('#PriceMax').val();
			        //$('#selectedPriceRange').remove();
			        //if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {
			        //    addSelectedPriceRange(priceMin, priceMax);
			        //}
			        //angular.element(document.getElementById('PriceMin')).triggerHandler('change');
			       // angular.element(document.getElementById('PriceMax')).triggerHandler('change');
			    }, 200);
		    }
	    });
	
	
	    if(SliderObject.length > 0) {
	            PriceMinObject.val(SliderObject.slider("values", 0).toFixed(2)); 
	            PriceMaxObject.val(SliderObject.slider("values", 1).toFixed(2));
	    }
    }//end SetupPriceSlider

    function SetupFilterMore(FilterObject) {
	    //Display the hidden filters
	     FilterObject.each(function() {
	            var moreLink = $(this);
	            moreLink.children("a:first").click(function(event) {
	                var SlideDiv = $(this).next("div");
	                SlideDiv.slideToggle("fast", function() {
	                    $(this).prev("a").html($(this).is(":hidden") ? "more &gt;" : "less &lt;");
	                });
	                return false;
	            });
	        
	            if (moreLink.find("input[type=checkbox]:checked").length <= 0) {
	                moreLink.children("a:first").next().hide();
	            }
	     });
    }//end SetupFilterMore

           
     function SetupFilterHeader(FilterHeaderObject) {
	     //Hide/display the specified filter section.
	     FilterHeaderObject.on('click', function() {
	            var hdr = $(this); 
	            var expandArrow = hdr.children("span.filterExpand");
	            var filterDropDown = hdr.siblings("div.filterContent");
	            //expandArrow.empty();
	            if (expandArrow.hasClass("filterExpandActive")) {
	                expandArrow.removeClass("filterExpandActive");
	                //expandArrow.append("<span class='visually-hidden'>Expand this filter</span>");
	                hdr.attr("aria-expanded", "true");
	                filterDropDown.attr("aria-hidden", "false");
	            } else {
	                expandArrow.addClass("filterExpandActive");
	               //expandArrow.append("<span class='visually-hidden'>Collapse this filter</span>");
	                hdr.attr("aria-expanded", "false");
	                filterDropDown.attr("aria-hidden", "true");
	            }
	            hdr.siblings("div").slideToggle("fast");
    	    });
    	     FilterHeaderObject.on('keypress', function(e) {
	    	     	if(e.which == 13){
	 			$(this).click();
		 	}
	     });
     }//end SetupFilterHeader

    function UpdateFilterUrl() {
        var newPath = UrlPath()
                    + UpdatedPriceFilterRouteParam()
                    + UpdatedColorFilterRouteParam()
                    + UpdatedRatingFilterRouteParam()
                    + UpdatedProdTimeRouteParam()
                    + UpdatedTagFilterRouteParam()
                    + UpdatedFilterQueryString();

        prodListValues.ReplaceCurrentUrl(newPath, productListMeta.GetTitle(), productListMeta.GetDescription(), productListMeta.GetKeywords());
    }

    function UpdatedPriceFilterRouteParam()
    {
        var priceFilter = '';
        var priceMin = $('#PriceMin').val();
        var priceMax = $('#PriceMax').val();
        if (PriceFilter.PriceMinimum < priceMin || PriceFilter.PriceMaximum > priceMax) {

            priceFilter = '/p/' + (priceMin * 100).toFixed() + '-' + (priceMax * 100).toFixed();
            productListMeta.SetPrice(priceMin, priceMax);
        } else {
            productListMeta.SetPrice("", "");
        }
        return priceFilter;
    }

    function UpdatedColorFilterRouteParam()
    {
        var colorFilters = $('#colorFilter').val().trim();
        if (colorFilters != '') {
            colorFilters = '/c/' + colorFilters.replace(/ /g, '-');
        }
        return colorFilters;
    }

    function UpdatedRatingFilterRouteParam()
    {
        var ratingFilters = $('#ratingFilter').val().trim();
        if (ratingFilters != '') {
            ratingFilters = '/r/' + ratingFilters.replace(/ /g, '-');
        }
        return ratingFilters;
    }

    function UpdatedProdTimeRouteParam()
    {
        var timeFilter = $('#productionTimeFilter').val().trim();
        if (timeFilter != '') {
            timeFilter = '/s/' + timeFilter;
        }
        return timeFilter;
    }

    function UpdatedTagFilterRouteParam()
    {
        var tagFilters = $('#tagFilter').val().trim();
        if (tagFilters == '') {
            return '';
        }
        var groupedTags = tagFilters.split('#');
        var i;
        var routeParam = '';
        for( i = 0; i < groupedTags.length; i++)
        {
            if (groupedTags[i] != "")
            {
                var tagInfo = groupedTags[i].split('_');
                routeParam = (routeParam == '' ? '' : routeParam + '-') + tagInfo[1];
            }
        }
        return '/t/' + routeParam;
    }

    //needed to remove any page values from querystring after filter update
    function UpdatedFilterQueryString()
    {
        var currentUrl = window.location.href;
        var newQueryString = '';
        var matches = prodListValues.SubSearchPattern.exec(currentUrl);
        if (matches != null)
        {
            newQueryString = '?' + matches[0];
        }
        matches = prodListValues.SortByPattern.exec(currentUrl);
        if(matches != null)
        {
            if(newQueryString == ''){
                newQueryString = '?' + matches[0];
            }else{
                newQueryString = newQueryString + '&' + matches[0];
            }
        }
        matches = prodListValues.ItemsPerPagePattern.exec(currentUrl);
        if (matches != null)
        {
            if (newQueryString == '') {
                newQueryString = '?' + matches[0];
            } else {
                newQueryString = newQueryString + '&' + matches[0];
            }
        }
        if ($('#aSearchQueryUrl').val().trim().length > 0) {
            if (newQueryString == '') {
                newQueryString = '?' + $('#aSearchQueryUrl').val();
            } else {
                newQueryString = newQueryString + '&' + $('#aSearchQueryUrl').val();
            }
        }
        return newQueryString;
    }

    function UrlPath() {
        var currentUrl = window.location.href;
        var baseUrl = '';
        var paramPattern = /\/[cprst]\/[0-9]/;
        var matches = paramPattern.exec(currentUrl);

        if ($('#FilterFriendlyUrl').val().length > 0) {
            baseUrl = $('#FilterFriendlyUrl').val();
        }
        else if (matches != null) {
            baseUrl = currentUrl.slice(0, matches.index);
        }
        else if (currentUrl.indexOf('?') >= 0){
            baseUrl = currentUrl.slice(0, currentUrl.indexOf('?'));
        }
        else {
            baseUrl = currentUrl;
        }
        var urlArray = currentUrl.split('/');
        var prot = urlArray[0];
        var host = urlArray[2];
        url = prot + '//' + host;
        return baseUrl.replace(url,'');
    }

    //set values from RouteData and QueryString
    function UpdatePageFromUrl()
    {
        var currentUrl = window.location.href;
        $('#selectedFilterList').html('');   //clear filterList
        /*set values for rewriten urls (i.e. 'athletic-tshirts' is 'tag/97/t/4531' */
        var defaultTag = $("#rewriteDefaultTag").val();  
        var defaultPrice = "";
        if($('#rewriteDefaultPrice').val() !== undefined ){
            defaultPrice = $('#rewriteDefaultPrice').val();
        }
        var urlVals = currentUrl.split('/');
        var urlVals2 = urlVals[3].split('?');
        if ($('#filterRewrite').val() == "") {
            if (defaultTag != "" && currentUrl.indexOf($('#FilterFriendlyUrl').val()) == -1) {
                var vals = currentUrl.split('/');
                $('#filterRewrite').val(urlVals2[0]);
            } else {
                defaultTag = "";
                $("#rewriteDefaultTag").val('');
                if (defaultPrice != "" && currentUrl.indexOf($('#FilterFriendlyUrl').val()) == -1) {
                    var vals = currentUrl.split('/');
                    $('#filterRewrite').val(urlVals2[0]);
                } else {
                    defaultPrice = "";
                    $("#rewriteDefaultPrice").val('');
                }
            }
        } else if ( urlVals2[0] != $('#filterRewrite').val()){
            defaultTag = "";
            defaultPrice = "";
        }

        /* set items per page from url */
        var matches = prodListValues.ItemsPerPagePattern.exec(currentUrl);
        if (matches != null) {
            $('#pageSizeFromUrl').val('true'); //don't default to page 1, don't insert new history
            var vals = matches[0].split('=');
            var value = vals[1];
            value = 'number:' + value;
            var options = document.getElementById('showOnPage').options;
            var valid = false;
            var i;
            for (i = 0; i < options.length ; i++) {
                if (options[i].value == value) {
                    options[i].selected = true;
                    valid = true;
                }
            }
            if (!valid) {
                options[0].selected = true;
            }
            angular.element(document.getElementById('showOnPage')).triggerHandler('change');
        } else {
            /* set default items per page */
            var defaultValue = 'number:'+ prodListValues.GetItemsPerPage();
            
            var options = document.getElementById('showOnPage').options;
            var change = false;
            var i;
            for (i = 0; i < options.length ; i++) {
                if (options[i].value == defaultValue) {
                    if(!options[i].selected){
                        change = true;
                        options[i].selected = true;
                    }
                }
            }
            if (change) {
                $('#pageSizeFromUrl').val('true');//don't default to page 1, don't insert new history
                angular.element(document.getElementById('showOnPage')).triggerHandler('change');
            }
        }

        /* set sub search from url */
        matches = prodListValues.SubSearchPattern.exec(currentUrl);
        if (matches != null) {
            var vals = matches[0].split('=');
            $('#txtInnerSearch').val(vals[1].replace('%20', ' '));
            $('#searchValue').val(vals[1].replace('%20', ' '));
            $('#searchFromUrl').val('true'); //don't default to page 1, don't insert new history
            angular.element(document.getElementById('txtInnerSearch')).triggerHandler('change');
            angular.element(document.getElementById('searchValue')).triggerHandler('change');
            $('#submitInnerSearch').click();
        } else if ($('#txtInnerSearch').val().trim().length > 0) {
            /* clear sub search */
            $('#txtInnerSearch').val('');
            $('#searchValue').val('');
            $('#searchFromUrl').val('true'); //don't default to page 1, don't insert new history
            angular.element(document.getElementById('txtInnerSearch')).triggerHandler('change');
            angular.element(document.getElementById('searchValue')).triggerHandler('change');
            $('#submitInnerSearch').click();
        }

        /* set filter order from url*/
        matches = prodListValues.SortByPattern.exec(currentUrl);
        var defaultOrder = 'string:-RelevenceScore';
        if (matches != null) {
            $('#sortFromUrl').val('true');
            var value = matches[0];
            var options = document.getElementById('sortBy').options;
            var option = '-RelevenceScore';
            var sortMeta = "";
            var valid = false;
            var i;
            for (i = 0; i < prodListValues.SortMap.length ; i++) {
                if (prodListValues.SortMap[i].q == value) {
                    option = prodListValues.SortMap[i].v;
                    sortMeta = prodListValues.SortMap[i].meta;
                    break;
                }
            }
            for (i = 0; i < options.length ; i++) {
                if (options[i].value == option) {
                    options[i].selected = true;
                    valid = true;
                    break;
                }
            }
            if (!valid) {
                options[1].selected = true;
            }
            productListMeta.SetOrder(sortMeta);
            angular.element(document.getElementById('sortBy')).triggerHandler('change');
        } else {
            /* set default filter order*/
            var options = document.getElementById('sortBy').options;
            var change = false;
            var i;
            for (i = 0; i < options.length ; i++) {
                if (options[i].value == defaultOrder) {
                    if (!options[i].selected) {
                        change = true;
                    }
                    options[i].selected = true;
                } else {
                    if (options[i].selected) {
                        change = true;
                    }
                }
            }
            productListMeta.SetOrder('');
            if (change) {
                $('#sortFromUrl').val('true'); //don't default to page 1, don't insert new history
                angular.element(document.getElementById('sortBy')).triggerHandler('change');
            }
        }

        /* set price filter from url */
        matches = prodListValues.PricePattern.exec(currentUrl);
        if (matches != null || defaultPrice != "") {
            var priceFilters = null;
            if (matches != null) {
                var vals = matches[0].split('/');
                priceFilters = vals[2].split('-');
            } else {
                priceFilters = defaultPrice.split('-');
            }
            var priceMin = (priceFilters[0] / 100).toFixed(2);
            var priceMax = (priceFilters[1] / 100).toFixed(2);
            if (priceMin < PriceFilter.PriceMinimum) {
                priceMin = PriceFilter.PriceMinimum;
            }
            if (priceMax > PriceFilter.PriceMaximum) {
                priceMax = PriceFilter.PriceMaximum;
            }
            addSelectedPriceRange(priceMin, priceMax);
            $('#PriceMinDisplay').val(priceMin);
            $('#PriceMaxDisplay').val(priceMax);
            $('#PriceMin').val(priceMin);
            $('#PriceMax').val(priceMax);
            $('#priceFromUrl').val('true'); //don't default to page 1, don't insert new history
            productListMeta.SetPrice(priceMin, priceMax);
            angular.element(document.getElementById('PriceMax')).triggerHandler('change');
            angular.element(document.getElementById('PriceMin')).triggerHandler('change');
            /*set slider css*/
            var range = PriceFilter.PriceMaximum - PriceFilter.PriceMinimum;
            var filteredRange = priceMax - priceMin;
            var l = priceMin - PriceFilter.PriceMinimum;
            var lp = 0;
            if(l > 0){
                lp = (l*100/range) + '%';
            }
            var rw = '0%';
            if (filteredRange > 0) {
                rw = (filteredRange * 100 / range) + '%';
            }
            $('#price-range > .ui-slider-range').css({ 'left': 0, 'width': '100%' });
            var c = $('#price-range > .ui-slider-handle');
            c.first().css('left', lp).addClass('pointer').append("<span class='visually-hidden'>Minimum price slider</span>");
            c.last().css('left', '100%').addClass('pointer').append("<span class='visually-hidden'>Maximum price slider</span>");
        } else if ($('#PriceMin').val() == '' || $('#PriceMax').val() == '' || $('#PriceMin').val() > PriceFilter.PriceMinimum || $('#PriceMax').val() < PriceFilter.PriceMaximum) {    
        	$('#PriceMinDisplay').val(PriceFilter.PriceMinimum.toFixed(2));
            $('#PriceMaxDisplay').val(PriceFilter.PriceMaximum.toFixed(2));
            $('#PriceMin').val(PriceFilter.PriceMinimum);
            $('#PriceMax').val(PriceFilter.PriceMaximum);
            $('#priceFromUrl').val('true'); //don't default to page 1, don't insert new history
            productListMeta.SetPrice("", "");
            angular.element(document.getElementById('PriceMax')).triggerHandler('change');
            angular.element(document.getElementById('PriceMin')).triggerHandler('change');

            /*set slider css*/
            $('#price-range > .ui-slider-range').css({ 'left': 0, 'width': '100%' });
            var c = $('#price-range > .ui-slider-handle');
            c.first().css('left',0).addClass('pointer').append("<span class='visually-hidden'>Minimum price slider</span>");
            c.last().css('left','100%').addClass('pointer').append("<span class='visually-hidden'>Maximum price slider</span>");
        }

        /* set color filters from url */
        matches = prodListValues.ColorPattern.exec(currentUrl);
        $('.colorChecked').children().css('display', 'none');
        $('.colorChecked').removeClass('colorChecked');
        if (matches != null) {
            var vals = matches[0].split('/');
            var colorMeta = "";
            var colorFilters = vals[2].split('-');
            var i;
            for (i = 0; i < colorFilters.length; i++) {
                var c = $('#chkColor_' + colorFilters[i]);
                addSelectedFilterColor(c[0]);
                if (!c.hasClass('colorChecked')) {
                    c.addClass('colorChecked');
                    c.children().css('display', '');
                }
                colorMeta = colorMeta + "_" + c[0].attributes['aria-label'].value;
            }
            $('#colorFromUrl').val('true'); //don't default to page 1, don't insert new history
            var filter = '';
            $('.colorChecked').each(function () { var vals = this.id.split('_'); filter = filter + ' ' + vals[1]; });
            $('#colorFilter').val(filter);
            productListMeta.SetColor(colorMeta);
            angular.element(document.getElementById('colorFilter')).triggerHandler('change');
        } else if($('#colorFilter').val().trim().length > 0){
            /* clear color filters */
            $('#colorFilter').val('');
            $('#colorFromUrl').val('true'); //don't default to page 1, don't insert new history
            productListMeta.SetColor("");
            angular.element(document.getElementById('colorFilter')).triggerHandler('change');
        }

        /* set rating filter from url */
        matches = prodListValues.RatingPattern.exec(currentUrl);
        $('.ratingFilter').prop('checked', false);
        $('.ratingFilterChecked').removeClass('ratingFilterChecked');
        if (matches != null) {
            var vals = matches[0].split('/');
            var ratingFilters = vals[2].split('-');
            var i;
            var ratingFilter = '';
            var ratingMeta = '';
            for (i = 0; i < ratingFilters.length; i++) {
                var r = $('#chkRating_' + ratingFilters[i]);
                r.prop('checked', true);
                r.addClass('ratingFilterChecked');
                var vals = r.prop('id').split('_');
                ratingFilter = ratingFilter + ' ' + vals[1];
                ratingMeta = ratingMeta + '_' + vals[1];
                addFilterToSelectedGroup(r[0]);
            }
            $('#ratingFromUrl').val('true'); //don't default to page 1, don't insert new history
            checkBoxUpdate = true;
            $('#ratingFilter').val(ratingFilter);
            productListMeta.SetRating(ratingMeta);
            angular.element(document.getElementById('ratingFilter')).triggerHandler('change');  
        } else if ($('#ratingFilter').val().trim().length > 0) {
            /* clear rating filters */
            $('#ratingFilter').val('');
            $('#ratingFromUrl').val('true'); //don't default to page 1, don't insert new history
            productListMeta.SetRating("");
            angular.element(document.getElementById('ratingFilter')).triggerHandler('change');
        }

        /* set production time filter from url */
        matches = prodListValues.ProdTimePattern.exec(currentUrl);
        if (matches != null) {
            var vals = matches[0].split('/');
            var timeFilter = vals[2];
            var t = $('#chkProductionTime_' + timeFilter);
            t.prop('checked', true);
            $('#prodTimeFromUrl').val('true'); //don't default to page 1, don't insert new history
            $('#productionTimeFilter').val(timeFilter);
            productListMeta.SetProductionTime(timeFilter);
            angular.element(document.getElementById('productionTimeFilter')).triggerHandler('change');
            addSelectedProductionTime(t[0]);
        } else if ($('#productionTimeFilter').val().trim().length > 0) {
            /* clear production time filter */
            $('.productionTimeFilter').prop('checked', false);
            $('#productionTimeFilter').val('');
            $('#prodTimeFromUrl').val('true'); //don't default to page 1, don't insert new history
            productListMeta.SetProductionTime("");
            angular.element(document.getElementById('productionTimeFilter')).triggerHandler('change');
        }

        /* set tag filters from url */
        matches = prodListValues.TagPattern.exec(currentUrl);
        $('.tagFilter').prop('checked', false);
        $('.tagFilterChecked').removeClass('tagFilterChecked');
        if (matches != null || defaultTag != '') {
            var tagFilters = [];
            if (matches != null) {
                var vals = matches[0].split('/');
                tagFilters = vals[2].split('-');
            }
            if (defaultTag.length > 0) {
                var tagVals = defaultTag.split('-');
                var h;
                for (h = 0; h < tagVals.length; h++) {
                    tagFilters.push(tagVals[h]);
                }
            }
            var i;
            var tagGroups = [];
            var tagMeta = '';
            for (i = 0; i < tagFilters.length; i++) {
                var t = $(".tagFilter[name='" + tagFilters[i] + "']");
                if (t.length > 0) {
                    t.prop('checked', true);
                    t.addClass('tagFilterChecked');
                    var vals2 = t.prop('id').split('_');
                    var groupID = vals2[1];
                    var j;
                    var contains = false;
                    for (j = 0; j < tagGroups.length; j++) {
                        if (tagGroups[j].group == groupID) {
                            tagGroups[j].tags.push(vals2[2]);
                            contains = true;
                            break;
                        }
                    }
                    addFilterToSelectedGroup(t[0]);
                    if (!contains) {
                        tagGroups.push({ 'group': groupID, 'tags': [vals2[2]] });
                    }
                    tagMeta = tagMeta + '_' + t[0].attributes["aria-label"].value
                }
            }
            productListMeta.SetTags(tagMeta);
            var l;
            var filterValue = '';
            for (l = 0; l < tagGroups.length; l++) {
                filterValue = filterValue + '#' + tagGroups[l].group + '_';
                var k;
                for (k = 0; k < tagGroups[l].tags.length; k++) {
                    if (k > 0) {
                        filterValue = filterValue + '-' + tagGroups[l].tags[k];
                    } else {
                        filterValue = filterValue + tagGroups[l].tags[k];
                    }
                }
            }
            $('#tagFromUrl').val('true'); //don't default to page 1, don't insert new history
            $('#tagFilter').val(filterValue);
            angular.element(document.getElementById('tagFilter')).triggerHandler('change');
        } else if ($('#tagFilter').val().trim().length > 0) {
            /* clear tag filters */
            $('#tagFromUrl').val('true'); //don't default to page 1, don't insert new history
            $('#tagFilter').val('');
            productListMeta.SetTags("");
            angular.element(document.getElementById('tagFilter')).triggerHandler('change');
        }
    }

    !function (angular, undefined) {
        'use strict';
        angular.module('Shared', [])
        .config(function ($provide, $locationProvider) {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });
            $provide.decorator("$location", locationDecorator);
            function locationDecorator($delegate, $rootScope) {
                var $location = $delegate;
                var skipping = false;
                $rootScope.$on('$locationChangeSuccess', function (event) {
                    if (skipping) {
                        event.preventDefault();
                        skipping = false;
                    }
                });
                // usage: $location.skipReload().path('/new/path').replace() to not insert history 
                //        or $location.skipReload().path('/new/path') to insert history
                $location.skipReload = function () {
                    skipping = true;
                    return this;
                };
                // Return the decorated service.
                return ($location);
            }
        });
    }(window.angular);


    function CreateColorFilterDiv(inputElement) {
        var newId = 'selected_' + inputElement.attributes['id'].value;
        var ariaLabel = inputElement.attributes['aria-label'].value;
        var bkgdColor = inputElement.style.backgroundColor;
        //  var filterClass = inputElement.attributes['class'].value;
        //  var stringthing = '<div id = "' + newId + '"><label class="text14 ' + filterClass + '">' + ariaLabel + '</label><a class = "icon icon-closeX noLine text16 floatRight" OnClick="removeSelfFromSelectedGroup(' + newId + ')" onkeypress="keyPressRemoveSelf(event, ' + newId + ')"></a></div><div class="clear"></div>';
        var stringthingcolor = '<div id="' + newId + '" class="clear"><div title="' + ariaLabel + '" class="filterColorBlock margin5 floatLeft borderDkGray" style="background-color:' + bkgdColor + ';" aria-label="' + ariaLabel + '"></div><label class="text14 margin5 floatLeft">' + ariaLabel + '</label><a class = "icon icon-closeX noLine text16 floatRight darkLink pointer" OnClick="removeSelfFromSelectedGroup(' + newId + ')"   onkeypress="keyPressRemoveSelf(event, ' + newId + ')" tabindex="0" title="Remove '+ ariaLabel + ' filter" ></a></div>';
        return stringthingcolor;
    }

    function addSelectedPriceRange(min, max) {
        var list = $('#selectedFilterList');
        var newDiv = CreatePriceRangeFilterDiv(min, max);
        list.append(newDiv);
        var sF = $('.selectedFilters');
        if (sF.hasClass("hide")) {
            sF.removeClass("hide").show();
        }
    }

    function addFilterToSelectedGroup(input) {
        var list = $('#selectedFilterList');
        //list.append(input.parentElement.outerText);
        var newDiv = CreateFilterDiv(input);//input.parentElement.outerText);
        list.append(newDiv);
        var sF = $('.selectedFilters');
        if (sF.hasClass("hide")) {
            sF.removeClass("hide").show();
        }
    }
    function CreateFilterDiv(inputElement) {
        //  var inputType = inputElement.attributes['type'].value; //checkbox, radio, color???
        //  var originalId = inputElement.attributes['id'].value;
        var newId = 'selected_' + inputElement.attributes['id'].value;
        //   var tagId = inputElement.attributes['name'].value;
        var ariaLabel = inputElement.attributes['aria-label'].value;
        var filterClass = '';//inputElement.attributes['class'].value;
        var stringthing = '<div id = "' + newId + '" class="clear"><label class="text14 margin5 ' + filterClass + '"><span class="visually-hidden">Now Showing</span>' + ariaLabel + '</label><a class = "icon icon-closeX noLine text16 floatRight darkLink pointer" OnClick="removeSelfFromSelectedGroup(' + newId + ')" onkeypress="keyPressRemoveSelf(event, ' + newId + ')" tabindex="0" title="Remove '+ ariaLabel + ' filter"></a></div>';
        return stringthing;
    }

    function CreateProductionTimeFilterDiv(inputElement) {
        //  var inputType = inputElement.attributes['type'].value; //checkbox, radio, color???
        //  var originalId = inputElement.attributes['id'].value;
        var newId = 'selected_' + inputElement.attributes['id'].value;
        //   var tagId = inputElement.attributes['name'].value;
        var ariaLabel = inputElement.attributes['aria-label'].value;
        var filterClass = '';//inputElement.attributes['class'].value;
        var stringthing = '<div id = "' + newId + '" class="clear selectedProductionTime"><label class="text14 margin5 ' + filterClass + '"><span class="visually-hidden">Now Showing</span>' + ariaLabel + '</label><a class = "icon icon-closeX noLine text16 floatRight darkLink pointer" OnClick="removeSelfFromSelectedGroup(' + newId + ')" onkeypress="keyPressRemoveSelf(event,'+ newId +')" tabindex="0" title="Remove '+ ariaLabel + ' filter" ></a></div>';
        return stringthing;
    }

    function CreatePriceRangeFilterDiv(min, max) {
        var stringthing = '<div id = "selectedPriceRange" class="clear selectedPriceRange"><label class="text14 margin5"><span class="visually-hidden">Now Showing</span>' + localizedJS.SelectedPriceRangeFormat.replace('##min##', min).replace('##max##', max) + '</label><a class = "icon icon-closeX noLine text16 floatRight darkLink pointer" OnClick="removePriceFilter()" onkeypress="keyPressRemovePriceFilter(event)" tabindex="0" title="Remove price filter" ></a></div>';
        return stringthing;
    }

    function removeFilterFromSelectedGroup(inputElement) {
        //remove the div in selected filters 
        $("#selected_" + inputElement.attributes['id'].value).remove();
        var list = $('#selectedFilterList');
        if (list[0].childElementCount < 1) {
            $('.selectedFilters').addClass('hide').hide();
        }
    }

    function addSelectedFilterColor(element) {
        var list = $('#selectedFilterList');
        var newDiv = CreateColorFilterDiv(element);
        list.append(newDiv);
        var sF = $('.selectedFilters');
        if (sF.hasClass("hide")) {
            sF.removeClass("hide").show();
        }
    }
    function addSelectedProductionTime(input) {
        var list = $('#selectedFilterList');
        //list.append(input.parentElement.outerText);
        var newDiv = CreateProductionTimeFilterDiv(input);//input.parentElement.outerText);

        list.append(newDiv);
        var sF = $('.selectedFilters');
        if (sF.hasClass("hide")) {
            sF.removeClass("hide").show();
        }
    }
    function popState(event) {
        angular.element(document.getElementById('currentPage')).triggerHandler('change'); //make sure existing page values where 'listened to'
        UpdatePageFromUrl();
        var current = window.location.href;
        var matches = prodListValues.PagePattern.exec(current);

        if (event.state != null) {
            document.title = event.state.title;
            $('meta[name="keywords"]').attr('content', event.state.keywords);
            $('meta[name="description"]').attr('content', event.state.description);
        }
        else {
            document.title = "";
            $('meta[name="keywords"]').attr('content', "");
            $('meta[name="description"]').attr('content', "");
        }
        
        if (matches != null) {
            var vals = matches[0].split('=');
            $('#currentPage').val(vals[1]);
        } else {
            $('#currentPage').val(1);
        }
        angular.element(document.getElementById('currentPage')).triggerHandler('change'); //trigger page refresh
    }
    
     function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    }
    
    function onResize(event){
    	        if ($('#collapsed').val() == 'true' && viewport().width >= 800) {
                $('.filterHeader').each( function(){
                    var hdr = $(this);
                    var expandArrow = hdr.children("span.filterExpand");
                    var filterDropDown = hdr.siblings("div.filterContent");
                    //expandArrow.empty();
                    if (expandArrow.hasClass("filterExpandActive")) {
                        expandArrow.removeClass("filterExpandActive");
                        //expandArrow.append("<span class='visually-hidden'>Expand this filter</span>");
                        hdr.attr("aria-expanded", "true");
                        filterDropDown.attr("aria-hidden", "false");
                        hdr.siblings("div").slideToggle("fast");
                    }  
                });
                $('#collapsed').val('false');
            }
            else if ($('#collapsed').val() == 'false' && viewport().width < 800) {
                $('.filterHeader').each(function () {
                    var hdr = $(this);
                    var expandArrow = hdr.children("span.filterExpand");
                    var filterDropDown = hdr.siblings("div.filterContent");
                    //expandArrow.empty();
                    if (!expandArrow.hasClass("filterExpandActive")) {
                        expandArrow.addClass("filterExpandActive");
                        //expandArrow.append("<span class='visually-hidden'>Collapse this filter</span>");
                        hdr.attr("aria-expanded", "false");
                        filterDropDown.attr("aria-hidden", "true");
                        hdr.siblings("div").slideToggle("fast");
                    }
                });
                $('#collapsed').val('true');
            }
    }
    
    function clearAllFilters() {
        //var searchChange = false;

        var currentUrl = window.location.href;
        $('#selectedFilterList').html('');   //clear filterList
        $('#clearingFilter').removeClass('hide').show();
        $('#clearAllFilters').addClass('hide').hide();
        setTimeout(function () {
            $('#currentPage').val(1);
            /*set values for rewriten urls (i.e. 'athletic-tshirts' is 'tag/97/t/4531' */
            var defaultTag = $("#rewriteDefaultTag").val();
            var defaultPrice = "";
            if ($("#rewriteDefaultPrice").val() !== undefined) {
                defaultPrice = $("#rewriteDefaultPrice").val();
            }
            var urlVals = currentUrl.split('/');
            var urlVals2 = urlVals[3].split('?');
            if ($('#filterRewrite').val() == "") {
                if (defaultTag != "" && currentUrl.indexOf($('#FilterFriendlyUrl').val()) == -1) {
                    var vals = currentUrl.split('/');
                    $('#filterRewrite').val(urlVals2[0]);
                } else {
                    defaultTag = "";
                    $("#rewriteDefaultTag").val('');
                    if (defaultPrice != "" && currentUrl.indexOf($('#FilterFriendlyUrl').val()) == -1) {
                        var vals = currentUrl.split('/');
                        $('#filterRewrite').val(urlVals2[0]);
                    } else {
                        defaultPrice = "";
                        $("#rewriteDefaultPrice").val('');
                    }
                }
            } else if (urlVals2[0] != $('#filterRewrite').val()) {
                defaultTag = "";
                defaultPrice = "";
            }


            /* set default items per page */
            var defaultValue = 'number:' + prodListValues.GetItemsPerPage();

            var options = document.getElementById('showOnPage').options;
            var change = false;
            var i;
            for (i = 0; i < options.length ; i++) {
                if (options[i].value == defaultValue) {
                    if (!options[i].selected) {
                        change = true;
                        options[i].selected = true;
                    }
                }
            }
            if (change) {
                $('#pageSizeFromUrl').val('true');//don't default to page 1, don't insert new history
                angular.element(document.getElementById('showOnPage')).triggerHandler('change');
            }


            if ($('#txtInnerSearch').val().trim().length > 0 || $('#searchValue').val().trim().length > 0) {
                /* clear sub search */
                $('#txtInnerSearch').val('');
                $('#searchValue').val('');
                $('#searchFromUrl').val('true'); //don't default to page 1, don't insert new history
                angular.element(document.getElementById('txtInnerSearch')).triggerHandler('change');
                angular.element(document.getElementById('searchValue')).triggerHandler('change');
                $('#submitInnerSearch').click();
            }

            /* clear filter order */
            matches = prodListValues.SortByPattern.exec(currentUrl);
            var defaultOrder = 'string:default';

            var options = document.getElementById('sortBy').options;
            var change = false;
            var i;
            for (i = 0; i < options.length ; i++) {
                if (options[i].value == defaultOrder) {
                    if (!options[i].selected) {
                        change = true;
                    }
                    options[i].selected = true;
                } else {
                    if (options[i].selected) {
                        change = true;
                    }
                }
            }
            productListMeta.SetOrder('');
            if (change) {
                $('#sortFromUrl').val('true'); //don't default to page 1, don't insert new history
                angular.element(document.getElementById('sortBy')).triggerHandler('change');
            }



            if ($('#PriceMin').val() == '' || $('#PriceMax').val() == '' || $('#PriceMin').val() > PriceFilter.PriceMinimum || $('#PriceMax').val() < PriceFilter.PriceMaximum) {
                $('#PriceMinDisplay').val(PriceFilter.PriceMinimum.toFixed(2));
                $('#PriceMaxDisplay').val(PriceFilter.PriceMaximum.toFixed(2));
                $('#PriceMin').val(PriceFilter.PriceMinimum);
                $('#PriceMax').val(PriceFilter.PriceMaximum);
                $('#priceFromUrl').val('true'); //don't default to page 1, don't insert new history
                productListMeta.SetPrice("", "");
                angular.element(document.getElementById('PriceMax')).triggerHandler('change');
                angular.element(document.getElementById('PriceMin')).triggerHandler('change');

                /*set slider css*/
                $('#price-range > .ui-slider-range').css({ 'left': 0, 'width': '100%' });
                var c = $('#price-range > .ui-slider-handle');
                c.first().css('left', 0).addClass('pointer').append("<span class='visually-hidden'>Minimum price slider</span>");
                c.last().css('left', '100%').addClass('pointer').append("<span class='visually-hidden'>Maximum price slider</span>");
            }

            $('.colorChecked').children().css('display', 'none');
            $('.colorChecked').removeClass('colorChecked');

            if ($('#colorFilter').val().trim().length > 0) {
                /* clear color filters */
                $('#colorFilter').val('');
                $('#colorFromUrl').val('true'); //don't default to page 1, don't insert new history
                productListMeta.SetColor("");
                angular.element(document.getElementById('colorFilter')).triggerHandler('change');
            }
            $('.ratingFilter').prop('checked', false);
            if ($('#ratingFilter').val().trim().length > 0) {
                /* clear rating filters */
                $('#ratingFilter').val('');
                $('#ratingFromUrl').val('true'); //don't default to page 1, don't insert new history
                productListMeta.SetRating("");
                angular.element(document.getElementById('ratingFilter')).triggerHandler('change');
            }

            if ($('#productionTimeFilter').val().trim().length > 0) {
                /* clear production time filter */
                $('.productionTimeFilter').prop('checked', false);
                $('#productionTimeFilter').val('');
                $('#prodTimeFromUrl').val('true'); //don't default to page 1, don't insert new history
                productListMeta.SetProductionTime("");
                angular.element(document.getElementById('productionTimeFilter')).triggerHandler('change');
            }
            $('.tagFilter').prop('checked', false);
            $('.tagFilterChecked').removeClass('tagFilterChecked');
            if ($('#tagFilter').val().trim().length > 0) {
                /* clear tag filters */
                $('#tagFromUrl').val('true'); //don't default to page 1, don't insert new history
                $('#tagFilter').val('');
                productListMeta.SetTags("");
                angular.element(document.getElementById('tagFilter')).triggerHandler('change');
            }

            prodListValues.ReplaceCurrentUrl(UrlPath(), productListMeta.GetTitle(), productListMeta.GetDescription(), productListMeta.GetKeywords());
            $('#clearAllFilters').removeClass('hide').show();
            $('#clearingFilter').addClass('hide').hide();
            $('.selectedFilters').addClass('hide').hide();
            
        }, 30);
    }
});//end js file, anything added after this will have a global scope....

function removeSelfFromSelectedGroup(inputElement) {
    //remove the div in selected filters
    $("#" + inputElement.attributes['id'].value).remove();
    //uncheck original box and update filtering
    var checkboxIdToRemove = "#" + inputElement.attributes['id'].value.split("selected_")[1];
    var element = $(checkboxIdToRemove);
    element.trigger("click");
    if (element[0].type == 'radio') {
        element.prop('checked', false);
    }
}

function keyPressRemoveSelf(e, inputElement){
	if(e.which == 13){
		removeSelfFromSelectedGroup(inputElement);
	}
}

function removePriceFilter() {
    //remove the div in selected filters
    $("#selectedPriceRange").remove();
    $('#PriceMin').val(PriceFilter.PriceMinimum);
    $('#PriceMax').val(PriceFilter.PriceMaximum);
    $('#PriceMinDisplay').val(PriceFilter.PriceMinimum.toFixed(2));
    $('#PriceMaxDisplay').val(PriceFilter.PriceMaximum.toFixed(2));
    productListMeta.SetPrice("", "");

    //kinda ugly...
    $('#updatetriggerurl').trigger('click');

    angular.element(document.getElementById('PriceMax')).triggerHandler('change');
    angular.element(document.getElementById('PriceMin')).triggerHandler('change');

    /*set slider css*/
    $('#price-range > .ui-slider-range').css({ 'left': 0, 'width': '100%' });
    var c = $('#price-range > .ui-slider-handle');
    c.first().css('left', 0);
    c.last().css('left', '100%');

    var list = $('#selectedFilterList');
    if (list[0].childElementCount < 1) {
        $('.selectedFilters').addClass('hide').hide();
    }
}

function keyPressRemovePriceFilter(e){
	if(e.which == 13){
		removePriceFilter();
	}
}

function removeSubSearchFilter(){
    $("#selectedSubSearch").remove();
    /* clear sub search */
    $('#txtInnerSearch').val('');
    $('#searchValue').val('');
    angular.element(document.getElementById('txtInnerSearch')).triggerHandler('change');
    angular.element(document.getElementById('searchValue')).triggerHandler('change');
    $('#submitInnerSearch').click();
            
    var list = $('#selectedFilterList');
    if (list[0].childElementCount < 1) {
        $('.selectedFilters').addClass('hide').hide();
    }
}


function keyPressRemoveSSFilter(e){
	if(e.which == 13){
		removeSubSearchFilter();
	}
}

function replaceURL(el) {
    el.onerror = null;
    el.src = el.name;
}